import { FormatCarouselItemsToBEParams, FormattedCarouselItems } from './types'

import { formatChildAttachments } from './formatChildAttachments'

import {
  CLICK_THROUGH_LINK,
  FB_PAGE_CHOICE,
  INSTA_ACCOUNT_CHOICE,
  INSTAGRAM_ACTOR_ID,
  LEAD_GEN_FORM,
  PRIMARY_TEXT_LIST
} from '../../../../../fields'

export const formatCarouselItemsToBE = ({
  values,
  items,
  tags
}: FormatCarouselItemsToBEParams): FormattedCarouselItems => {
  const { [INSTA_ACCOUNT_CHOICE]: instagramAccountChoice, [FB_PAGE_CHOICE]: facebookPageChoice } = values

  // use first element from primary text list
  const adText = values[PRIMARY_TEXT_LIST]?.[0].text

  // FB requires this field for a carousel ad, so the link is taken from first Carousel item
  const clickThroughLink = items[0][CLICK_THROUGH_LINK]

  return {
    ...(tags && { url_tags: tags }),
    // page_id and instagram_user_id should be added in 2 places, do not remove any of them
    actor_id: facebookPageChoice,
    ...(instagramAccountChoice && { [INSTAGRAM_ACTOR_ID]: instagramAccountChoice }),
    object_story_spec: {
      link_data: {
        ...(adText && { message: adText }),
        multi_share_end_card: false,
        multi_share_optimized: false,
        ...(values[LEAD_GEN_FORM] && {
          call_to_action: {
            value: {
              [LEAD_GEN_FORM]: values[LEAD_GEN_FORM]
            }
          }
        }),
        link: clickThroughLink,
        child_attachments: formatChildAttachments(items)
      },
      // page_id and instagram_user_id should be added in 2 places, do not remove any of them
      page_id: facebookPageChoice,
      ...(instagramAccountChoice && { [INSTAGRAM_ACTOR_ID]: instagramAccountChoice })
    }
  }
}
